import type { Component, Entity2D } from '../../odie';

import type { MushroomBlockProps } from '../defs/block';
import { MushroomBlockView } from '../views/blocks/MushroomBlockView';

// types
//-----------------------------------------------------------------------------
export type MushroomBlockComponentOptions = {
  props: MushroomBlockProps;
};

/*
    mushroom block component
*/
export class MushroomBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockMushroom';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: MushroomBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: MushroomBlockComponentOptions): void {
    // create mushroom block view
    this.view = new MushroomBlockView(options.props);
  }
}
